// @flow

import { css } from '@emotion/react'
import styled from '@emotion/styled'
import * as React from 'react'
import Carousel from 'react-multi-carousel'

import { colors, media } from '@toggl/style'

import * as Responsive from '../responsive'

import 'react-multi-carousel/lib/styles.css'

type Props = {
  children: React.Node[],
}

export function CarouselDotMobile({ children }: Props) {
  const settings = {
    responsive: {
      all: {
        items: 1,
        breakpoint: { min: 0, max: 799 },
        partialVisibilityGutter: 15,
      },
    },
    ssr: true,
    deviceType: 'all',
    partialVisible: true,
    infinite: true,
    arrows: false,
    showDots: true,
    customDot: <Dot />,
    renderDotsOutside: true,
    slidesToSlide: 1,
    transitionDuration: 500,
    focusOnSelect: true,
  }

  return (
    <Root>
      <Responsive.MobileOnly>
        <Wrapper>
          <Carousel {...settings}>{children}</Carousel>
        </Wrapper>
      </Responsive.MobileOnly>

      <Responsive.DesktopOnly>{children}</Responsive.DesktopOnly>
    </Root>
  )
}

const Dot = styled.li`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: ${(p) => (p.active ? colors.beige : colors.purple60)};
`

const dotListStyles = css`
  .react-multi-carousel-dot-list {
    position: relative;
    margin: 20px auto;
    display: flex;
    justify-content: space-between;
    align-content: stretch;
    max-width: 10%;

    ${media.mq[1]} {
      display: none;
    }
  }
`

const Root: React.ComponentType<any> = styled.div`
  ${dotListStyles};
  max-width: 100%;

  ${media.mq[1]} {
    display: flex;
    justify-content: center;
    margin-top: 60px;
    flex-wrap: wrap;
  }

  ${media.mq[2]} {
    flex-wrap: nowrap;
    justify-content: space-between;
  }
`

const Wrapper = styled.div`
  padding: 0 15px;
`
